import { FETCH_LAUNDRY_CONFIGS } from './SettingsActions'
import {
  FETCH_VISIT_CHECKLIST_QUESTIONS,
  REORDER_VISIT_CHECKLIST_QUESTIONS,
} from './VisitChecklistActions'

const INITIAL_STATE = {
  laundryConfigs: [],
  visitChecklistQuestions: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LAUNDRY_CONFIGS.SUCCESS:
      return {
        ...state,
        laundryConfigs: action.payload.data,
      }
    case FETCH_VISIT_CHECKLIST_QUESTIONS.SUCCESS:
    case REORDER_VISIT_CHECKLIST_QUESTIONS.SUCCESS:
      return {
        ...state,
        visitChecklistQuestions: action.payload.data,
      }
    default:
      return state
  }
}
